import {NgModule} from '@angular/core';

import 'reflect-metadata';

import {ProfilePanelComponent} from './view/ac-system-header/profile-panel/profile-panel.component';
import {NotificationPanelComponent} from './view/ac-system-header/notification-panel/notification-panel.component';
import {EmailModule} from 'projects/app-misc/src/app/modules/email/email.module';
import {AppComponent} from './app.component';
import {CommonModule} from '@angular/common';
import {API_URL, LoginModule, CoreModule, MiscModule, SOCKET_URL} from 'projects/core/src/public-api';
import {environment} from '../environments/environment';
import {ACCalendarModule} from './modules/full-calendar/ac-calendar.module';
import {DesktopProjectModule} from './modules/project/desktop-project.module';
import {AppRoutingModule} from './app-routing.module';
import {AcSystemHeaderComponent} from './view/ac-system-header/ac-system-header.component';
import {ProfileEditComponent} from './view/profile/profile-edit/profile-edit.component';
import {
  ChangePasswordDialogComponent
} from './view/profile/profile-edit/change-password-dialog/change-password-dialog.component';

import {OverlayPanelModule} from 'primeng/overlaypanel';
import {PaginatorModule} from 'primeng/paginator';
import {SearchResultsPanelComponent} from './view/ac-system-header/search-results-panel/search-results-panel.component';
import {CustomerModule} from './modules/customer/customer.module';
import {TimesheetsModule} from './modules/timesheets/timesheets.module';
import {KanbanBoardModule} from './modules/kanban-board/kanban-board.module';
import {ProjectMiscModule} from 'projects/app-misc/src/app/modules/project-misc/project-misc.module';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {NotificationModule} from 'projects/app-misc/src/app/modules/notification/notification.module';
import {UsersModule} from 'projects/app-misc/src/app/modules/users/users.module';
import {TooltipModule} from 'primeng/tooltip';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRippleModule} from '@angular/material/core';
import {SystemClockComponent} from './view/ac-system-header/system-clock/system-clock.component';
import {PunchWidgetModule} from 'projects/app-misc/src/app/modules/punch-time-widget/punch-widget.module';
import {TestsPageModule} from 'projects/app-misc/src/app/tests-page/tests-page.module';
import {CalendarModule} from 'primeng/calendar';
import {BrowserModule} from '@angular/platform-browser';
import {VendorsModule} from './modules/vendor/vendors.module';
import {OrdersModule} from './modules/order/orders.module';
import {HomePageModule} from './modules/home-page/home-page.module';
import {SystemAlertsModule} from './modules/alerts/system-alerts.module';
import {TestsModule} from './view/test/tests.module';
import {ClientNfsModule} from './view/notification/notification.module';
import {ReportsModule} from 'projects/app-misc/src/app/modules/reports/reports.module';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {MentionPanelComponent} from './view/ac-system-header/mention-panel/mention-panel.component';
import {AdminPanelModule} from 'projects/app-misc/src/app/modules/admin-panel/admin-panel.module';
import {CanUserActivateRouteGuard} from 'projects/core/src/lib/login/data/can-user-activate-route-guard';
import {ProjectCalcModule} from 'projects/app-misc/src/app/modules/project-calc/project-calc.module';
import {
  ProductionPlanningModule
} from '../../../app-misc/src/app/modules/production-planning/production-planning.module';
import {LogisticRoutesModule} from '../../../app-misc/src/app/modules/logistic-routes/logistic-routes.module';
import { AlertsPanelComponent } from './view/ac-system-header/alerts-panel/alerts-panel.component';

@NgModule({
  declarations: [
    AppComponent,
    AcSystemHeaderComponent,
    ProfileEditComponent,
    ChangePasswordDialogComponent,
    ProfilePanelComponent,
    NotificationPanelComponent,
    SearchResultsPanelComponent,
    SystemClockComponent,
    MentionPanelComponent,
    AlertsPanelComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    LoginModule,
    CoreModule,
    AppRoutingModule,
    ACCalendarModule,
    DesktopProjectModule,
    CustomerModule,
    MiscModule,
    EmailModule,
    OverlayPanelModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    MatRippleModule,
    PaginatorModule,
    TooltipModule,
    TimesheetsModule,
    KanbanBoardModule,
    ProjectMiscModule,
    AutoCompleteModule,
    NotificationModule,
    PunchWidgetModule,
    UsersModule,
    TestsPageModule,
    TestsModule,
    CalendarModule,
    VendorsModule,
    OrdersModule,
    HomePageModule,
    SystemAlertsModule,
    ClientNfsModule,
    NgxExtendedPdfViewerModule,
    ReportsModule,
    AdminPanelModule,
    ProjectCalcModule,
    ProductionPlanningModule,
    LogisticRoutesModule
],
  providers: [
    {provide: API_URL, useValue: environment.apiUrl},
    {provide: SOCKET_URL, useValue: environment.socketUrl},
    CanUserActivateRouteGuard
  ],
  entryComponents: [
    ProfileEditComponent,
    ChangePasswordDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
